import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphEdge } from '../../../../core/models/chat.models';

@Component({
  selector: 'app-edge-details-sidebar',
  imports: [CommonModule],
  templateUrl: './edge-details-sidebar.component.html',
  styleUrls: ['./edge-details-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EdgeDetailsSidebarComponent implements OnChanges {
  @Input() edge: GraphEdge | null = null;
  @Output() close = new EventEmitter<void>();

  hasProperties = false;
  properties: { key: string, value: any }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['edge']) {
      this.computeProperties();
    }
  }

  private computeProperties(): void {
    if (!this.edge || !this.edge.properties) {
      this.hasProperties = false;
      this.properties = [];
      return;
    }

    this.hasProperties = Object.keys(this.edge.properties).length > 0;
    this.properties = Object.entries(this.edge.properties).map(([key, value]) => ({ key, value }));
  }

  trackByKey(index: number, prop: { key: string, value: any }): string {
    return prop.key;
  }
}
